<template>
  <div class="hc-compact-page px-6 py-6">

    <!-- Header Card -->
        <PageHeader icon="fas fa-hospital-alt">
      <template #title>
        Poliklinik {{ clinic_name }}
      </template>
      <template #subtitle>
        Kelola daftar poliklinik dan departemen layanan medis
      </template>
      <template #actions>
        <b-button
                class="btn btn-primary font-weight-bold px-6 hc-btn-tambah-jadwal"
                @click="$router.push('/polyclinic/add')">
                <i class="fas fa-plus"></i>
                <span>Tambah Poliklinik</span>
              </b-button>
      </template>
    </PageHeader>

    <!-- Component List -->
    <div class="row">
      <div class="col-md-12">
        <div class="card card-custom gutter-b shadow-xs border border-light">
          <div class="card-body p-6">

            <!-- Filter & Search Toolbar -->
            <div class="row align-items-center justify-content-between mb-6">
              <div class="col-md-6 mb-3 mb-md-0">
                <span class="text-muted font-size-sm font-weight-bold">Total Departments: {{ totalRows }}</span>
              </div>
              <div class="col-md-6 col-12">
                <div class="search-box-wrapper d-flex align-items-center justify-content-end">
                  <div class="search-input-control mr-2" style="max-width: 280px;">
                    <i class="fas fa-search search-icon"></i>
                    <b-form-input
                      type="text"
                      v-model="filter.name"
                      placeholder="Search Polyclinic name..."
                      class="search-input"
                      @keyup.enter="filterName"
                    ></b-form-input>
                  </div>
                  <b-button @click="filterName" class="btn-search mr-2">Cari</b-button>
                  <b-button @click="resetFilter" class="btn-reset">Reset</b-button>
                </div>
              </div>
            </div>

            <!-- Table -->
            <div class="table-responsive">
              <b-table hover class="mt-3 table-borderless table-vertical-center" :items="items" :fields="fields" style="font-size: 0.875rem;">
                <template #table-colgroup="scope">
                  <col v-for="field in scope.fields" :key="field.key"
                    :style="{ width: field.key === 'actions' ? '20%' : '' }" />
                </template>

                <template #head()="data">
                  <span style="font-size: 0.8rem; text-transform: uppercase; color: #64748B; font-weight: 700;">{{ data.label }}</span>
                </template>

                <template #cell(number)="data">
                  <span class="font-weight-bold text-dark">{{ data.value }}</span>
                </template>

                <template #cell(name)="data">
                  <span class="font-weight-bolder text-dark">{{ data.value }}</span>
                </template>

                <template #cell(description)="data">
                  <span class="text-muted">{{ data.value ? data.value : '-' }}</span>
                </template>

                <template #cell(actions)='data'>
                  <div class="d-flex">
                    <b-button size="sm" class="mr-1 btn-icon btn-light-primary" v-b-tooltip.hover title="Dokter"
                      @click="setSelectedPolyclinic(data.item.id, data.item.name)" v-b-modal.modal-doctor><i
                        class="fas fa-user-md"></i></b-button>
                    <b-button size="sm" class="mr-1 btn-icon btn-light-info" v-b-tooltip.hover title="Detail"
                      @click="$router.push({ path: '/polyclinic/detail/' + data.item.id })"><i
                        class="fas fa-eye"></i></b-button>
                    <b-button size="sm" class="mr-1 btn-icon btn-light-success" v-b-tooltip.hover title="Edit"
                      @click="$router.push({ path: '/polyclinic/edit/' + data.item.id })"><i
                        class="fas fa-edit"></i></b-button>
                    <b-button size="sm" class="btn-icon btn-light-danger" v-b-tooltip.hover title="Hapus"
                      @click="btnDeleteOnClick(data.item.id)"><i class="fas fa-trash"></i></b-button>
                  </div>
                </template>
              </b-table>
            </div>
            <b-pagination v-if="items.length != 0" v-model="currentPage" :total-rows="totalRows" :per-page="perPage"
              @page-click="pageOnClick" class="mt-6 mb-0 pagination-sm" style="margin-top: 20px;"></b-pagination>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="modal-doctor" hide-header hide-footer size="xl"
      modal-class="medhop-lookup-modal medhop-doctor-modal"
      body-class="medhop-lookup-modal__body"
      @hidden="modalDoctorOnHide">
      <header class="medhop-lookup-modal__header">
        <span class="medhop-lookup-modal__icon"><i class="fas fa-user-md"></i></span>
        <div>
          <h2>Dokter {{ selectedPolyclinic.name }}</h2>
          <p>Daftar dokter yang melayani pada poliklinik ini.</p>
        </div>
        <button type="button" class="medhop-lookup-modal__close" aria-label="Tutup" @click="$bvModal.hide('modal-doctor')">
          <i class="fas fa-times"></i>
        </button>
      </header>
      <Table purpose="polyclinic-modal" :polyclinicId="selectedPolyclinic.id" />
    </b-modal>

  </div>
</template>

<script>

import Card from "@/view/content/Card.vue"
import { debouncer } from "@/core/modules/Helper.js"
import Table from "@/component/doctors/Table.vue"
import module from "@/core/modules/CrudModule.js"
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module"

export default {

  components: {
    Card,
    Table,
  },

  data() {
    return {
      // Filter
      filter: {
        name: "",
      },
      // Pagination
      perPage: 20,
      currentPage: 1,
      totalRows: 0,
      // Table Head
      fields: [
        {
          key: "number",
          label: "#",
          sortable: true,
        },
        {
          key: "name",
          label: "Nama",
          sortable: true,
        },
        {
          key: "description",
          label: "Deskripsi",
          sortable: true,
          tdClass: 'text-truncate'
        },
        { key: "actions", label: "Aksi" },
      ],
      // Table Items
      items: [],
      // Other
      selectedPolyclinic: {
        id: "",
        name: "",
      },
      clinic_name: window.configuration == null ? "Medhop" : window.configuration.clinic_name
    }
  },

  methods: {

    pageOnClick(page) {
      this.currentPage = page
      this.pagination()
    },

    async pagination() {
      let filterParams = `&name=${this.filter.name}`
      let response = await module.paginate("polyclinics", `?page=${this.currentPage}&page_size=${this.perPage}${filterParams}`)
      let pagination = response.meta.pagination
      this.totalRows = pagination.total
      let a, b
      b = this.perPage * (this.currentPage - 1) + 1
      for (a = 0; a < response.data.length; a++) {
        response.data[a].number = b + a
      }
      this.items = response.data
    },

    setSelectedPolyclinic(id, name) {
      this.selectedPolyclinic.id = id
      this.selectedPolyclinic.name = name
    },

    modalDoctorOnHide() {
      this.selectedPolyclinic = { id: "", name: "" }
    },

    async btnDeleteOnClick(id) {
      // Delete Data
      let result = await module.delete("polyclinics/" + id);
      // If Deleted
      if (result) {
        this.pagination()
      }
    },

    filterName() {
      this.pagination()
    },
    resetFilter(){
      this.filter.name = ""
      this.pagination()
    }

  },

  computed: {
    getLanguageFlag() {
      return "";
    }
  },

  mounted() {
    // BreadCrumb
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Poliklinik" },
      { title: "Daftar Poliklinik" },
    ]);
    // Get Data
    this.pagination()
  },

}
</script>

<style lang="scss" scoped>
.hc-compact-page {
  font-family: "Poppins", "Inter", sans-serif;
}

/* Header Welcome Card */
.alert-custom {
  border-radius: 16px !important;
  border: 1px solid rgba(231, 237, 244, 0.92) !important;
  box-shadow: 0 10px 30px rgba(20, 50, 99, 0.03) !important;
  background: #ffffff !important;
  padding: 16px 24px !important;
  display: flex;
  align-items: center;
  
  .alert-icon {
    background-color: rgba(30, 149, 143, 0.08) !important;
    border-radius: 12px;
    padding: 10px;
    color: #1e958f !important;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 15px;
    
    svg {
      fill: #1e958f !important;
      color: #1e958f !important;
      width: 20px;
      height: 20px;
    }
  }

  .alert-text {
    color: #1e293b;
    flex-grow: 1;
    
    .welcome-title {
      font-size: 20px;
      font-weight: 700;
      color: #0f172a;
      margin: 0;
    }
  }

  /* Add Button */
  .btn-action-primary {
    background: linear-gradient(135deg, #14608f, #1e958f) !important;
    border: none !important;
    color: white !important;
    font-weight: 600 !important;
    font-size: 13px !important;
    height: 42px !important;
    padding: 0 20px !important;
    border-radius: 10px !important;
    box-shadow: 0 4px 12px rgba(30, 149, 143, 0.2) !important;
    transition: all 0.2s ease;
    display: inline-flex;
    align-items: center;
    
    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 6px 16px rgba(30, 149, 143, 0.3) !important;
    }
  }
}

/* Card Styling */
.card {
  border-radius: 18px !important;
  border: 1px solid #e2e8f0 !important;
  box-shadow: 0 12px 36px rgba(20, 50, 99, 0.03) !important;
  background: #ffffff;
  overflow: hidden;
}

/* Search Wrapper & Controls */
.search-box-wrapper {
  display: flex;
  align-items: center;
  width: 100%;
  
  .search-input-control {
    position: relative;
    flex-grow: 1;
    
    .search-icon {
      position: absolute;
      left: 14px;
      top: 50%;
      transform: translateY(-50%);
      color: #94a3b8;
      font-size: 13px;
      pointer-events: none;
      z-index: 5;
    }
    
    .search-input {
      padding-left: 38px !important;
      height: 40px !important;
      border-radius: 10px !important;
      border: 1px solid #e2e8f0 !important;
      background-color: #f8fafc !important;
      font-size: 13px !important;
      
      &:focus {
        border-color: #1e958f !important;
        background-color: #ffffff !important;
        box-shadow: 0 0 0 3px rgba(30, 149, 143, 0.1) !important;
      }
    }
  }

  .btn-search {
    background: linear-gradient(135deg, #14608f, #1e958f) !important;
    border: none !important;
    color: #ffffff !important;
    font-weight: 600 !important;
    font-size: 13px !important;
    height: 40px !important;
    padding: 0 20px !important;
    border-radius: 10px !important;
    box-shadow: 0 4px 12px rgba(30, 149, 143, 0.15) !important;
    transition: all 0.2s ease;
    
    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 6px 16px rgba(30, 149, 143, 0.25) !important;
    }
  }

  .btn-reset {
    background-color: #f8fafc !important;
    border: 1px solid #e2e8f0 !important;
    color: #475569 !important;
    font-weight: 600 !important;
    font-size: 13px !important;
    height: 40px !important;
    padding: 0 18px !important;
    border-radius: 10px !important;
    transition: all 0.2s ease;
    
    &:hover {
      background-color: #f1f5f9 !important;
      color: #0f172a !important;
    }
  }
}

/* Action Buttons styling */
.btn-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 8px !important;
  padding: 0 !important;
  border: none !important;
  transition: all 0.2s ease;
  
  i {
    font-size: 12px !important;
  }
  
  &.btn-light-primary {
    background-color: rgba(30, 149, 143, 0.08) !important;
    
    i {
      color: #1e958f !important;
    }
    
    &:hover {
      background-color: #1e958f !important;
      i {
        color: #fff !important;
      }
    }
  }
  
  &.btn-light-info {
    background-color: rgba(37, 99, 235, 0.08) !important;
    
    i {
      color: #2563eb !important;
    }
    
    &:hover {
      background-color: #2563eb !important;
      i {
        color: #fff !important;
      }
    }
  }
  
  &.btn-light-success {
    background-color: rgba(5, 150, 105, 0.08) !important;
    
    i {
      color: #059669 !important;
    }
    
    &:hover {
      background-color: #059669 !important;
      i {
        color: #fff !important;
      }
    }
  }
  
  &.btn-light-danger {
    background-color: rgba(220, 38, 38, 0.08) !important;
    
    i {
      color: #dc2626 !important;
    }
    
    &:hover {
      background-color: #dc2626 !important;
      i {
        color: #fff !important;
      }
    }
  }
}
</style>
